module.exports = __webpack_public_path__ + "img/alb-educativo.d3a27029.jpg";